import {Filtro} from './filtros/filtro';
import {CondicaoTypes} from '~utils/condicao-types';

export class FiltroContainer<T> {

  private readonly dados: T[] = [];
  private readonly condicao: CondicaoTypes = CondicaoTypes.IF;
  private filtros: Filtro<T>[] = [];

  constructor(
    dados: T[],
    condicao: CondicaoTypes
  ) {
    this.condicao = condicao;
    this.dados = dados;
  }

  removerFiltrosVazios(): void {
    this.filtros = this.filtros.filter((filtro) => filtro.getComparadores().length >= 1);
  }

  aplicar(): T[] {
    this.removerFiltrosVazios();
    return this.condicao === CondicaoTypes.OR ?
      this.filtroOr(this.dados) :
      this.filtroIf(this.dados);
  }

  addFiltro(filtro: Filtro<T>): void {
    this.filtros = this.filtros.concat(filtro);
  }

  addFiltros(filtros: Filtro<T>[]): void {
    this.filtros = this.filtros.concat(filtros);
  }

  private filtroIf(dados: T[]): T[] {
    let arr: T[] = dados;

    this.filtros.forEach(filtro => arr = filtro.filtrar(arr));

    return arr;
  }

  private filtroOr(dados: T[]): T[] {
    const arr: T[] = [];

    this.filtros.forEach(filtro => {
      filtro.filtrar(dados).forEach(obj => arr.push(obj));
    });

    return arr;
  }

}
